/** Overlay that contains a searchable option list. */
export const POPOVER_LIST_ROOT_ATTR = "data-popover-list-root";

/** Search field that must receive caret focus when the overlay opens. */
export const POPOVER_LIST_SEARCH_ATTR = "data-popover-list-search";

/** Option row that Enter confirms (highlighted, else first enabled). */
export const POPOVER_LIST_OPTION_ATTR = "data-popover-list-option";
